import AppFavManager from '../app-fav-manager'
import AppFilters from '../app-filters'

export default
{
    components:
    {
        AppFavManager,
        AppFilters
    },

    props:
    {

    },

    mounted()
    {

    },

    methods:
    {
        onSwitchLang()
        {
            this.$emit('switch:lang')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-nav-mobile/script.js